module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-4.506a1a5b.jpg";